export default __webpack_public_path__ + "static/media/ftp.ef50749f.svg";